/**
 * QUEST TYPES — the organizing dimension of the quest index (Nick, 2026-08-31:
 * "marketing quests, audience building quests, etc").
 *
 * Pre-feed's `priorityMode` pattern verbatim: the DB column is plain TEXT and THIS list
 * is the authority, so adding a type is one entry here — no migration, no enum type to
 * alter. Declaration order is the index page's section order. The resolver validates
 * against `QUEST_TYPE_VALUES` at the boundary.
 */
export const QUEST_TYPES = [
  { value: 'marketing', label: 'Marketing', emoji: '\u{1F4E3}' },
  { value: 'audience-building', label: 'Audience Building', emoji: '\u{1FAC2}' },
  { value: 'portfolio', label: 'Portfolio', emoji: '\u{1F5BC}\u{FE0F}' },
  { value: 'community', label: 'Community', emoji: '\u{1F4AC}' },
  { value: 'general', label: 'General', emoji: '\u{2728}' },
] as const;

export type QuestTypeValue = (typeof QUEST_TYPES)[number]['value'];

export const QUEST_TYPE_VALUES = QUEST_TYPES.map((entry) => entry.value) as QuestTypeValue[];

export function questTypeLabel(value: string): string {
  return QUEST_TYPES.find((entry) => entry.value === value)?.label ?? value;
}

/**
 * The type's default icon — what a quest wears when it has set no `emoji` of its own.
 *
 * This lives HERE, beside the type list, because it had drifted into four separate
 * copies (both quest bands, the tile component, and the admin editor's preview). Four
 * copies means adding a quest type silently shows the wrong icon on whichever surface
 * you forget, with nothing to catch it. One registry, one edit.
 */
export function questTypeEmoji(value: string | null | undefined): string {
  return QUEST_TYPES.find((entry) => entry.value === value)?.emoji ?? '\u{2728}';
}
